import template from './appPromote.html'
import './appPromote.less'

class AppPromoteController {
    constructor() {
        'ngInject';
    }
}

export const AppPromoteComponent = {
    name: 'appPromote',
    component: {
        template: template,
        controller: AppPromoteController,
        bindings: {
            expired: '<',
            onClickViewSchedule: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/appPromote/appPromote.component.js